import React from "react";
import { Box } from "@mui/material";
import { Form } from "react-final-form";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { validateForm } from "./AccountForm.services";
import { useAccountForm } from "../../hooks/AccountForm";
import {
  submitAccountUpdate,
  handleAccountDeletion,
} from "./AccountForm.services";
import { useSignInSignUp } from "../../hooks/useSignInSignUp";
import { HeaderSection } from "./components/HeaderSection";
import { PersonalInfoFields } from "./components/PersonalInfoFields";
import { AccountActionsSection } from "./components/AccountActionsSection";
import { DeleteAccountSection } from "./components/DeleteAccountSection";
import * as styles from "./AccountForm.styles";
import { getLabel, accountLabels } from "./components/AccountLabel";
import { TERTIARY, NEUTRAL_50, ACCOUNT_TEXTS } from "../../constants";
export default function AccountForm({ isMobile }) {
  const dispatch = useAppDispatch();
  const { user, isUserAnonymous } = useAppSelector(
    (state) => state.userReducer
  );
  const { firstName, lastName, numero, email } = user;

  const {
    loading,
    setLoading,
    isPhoneIncorrect,
    setIsPhoneIncorrect,
    setPhone,
    phoneObj,
    updatePhoneObj,
  } = useAccountForm(numero);

  const { handleForgetPassword } = useSignInSignUp();
  const navigate = useNavigate();

  const onSubmit = ({ firstName, lastName, numero }: any) =>
    submitAccountUpdate({
      isPhoneIncorrect,
      numero,
      phoneObj,
      user,
      firstName,
      lastName,
      dispatch,
      setLoading,
    });

  const onDelete = () =>
    handleAccountDeletion({ dispatch, user, isUserAnonymous, navigate });

  return (
    <Form
      validate={validateForm}
      onSubmit={onSubmit}
      initialValues={{ firstName, lastName, numero, email }}
      render={({ handleSubmit, form }) => (
        <>
          <HeaderSection
            onClick={() => form.submit()}
            loading={loading}
            label={getLabel(accountLabels.profileTitle, isMobile)}
            buttonName="Sauvegarder"
            leftIcon="Heart"
          />

          <Box sx={styles.bodyBox}>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <Box sx={styles.formWrapper}>
                <PersonalInfoFields
                  setPhone={setPhone}
                  setIsPhoneIncorrect={setIsPhoneIncorrect}
                  updatePhoneObj={updatePhoneObj}
                  isPhoneIncorrect={isPhoneIncorrect}
                />
                <Box sx={styles.passwordBox}>
                  <AccountActionsSection
                    onClick={() => handleForgetPassword(email)}
                    color={NEUTRAL_50}
                    colorType={TERTIARY}
                    title={ACCOUNT_TEXTS.PASSWORD.TITLE}
                    subTitle={ACCOUNT_TEXTS.PASSWORD.SUBTITLE}
                    buttonLabel={ACCOUNT_TEXTS.PASSWORD.BUTTON_LABEL}
                    buttonIcon={ACCOUNT_TEXTS.PASSWORD.ICON}
                    description={ACCOUNT_TEXTS.PASSWORD.DESCRIPTION}
                  />
                  <DeleteAccountSection onDelete={onDelete} />
                </Box>
              </Box>
            </form>
          </Box>
        </>
      )}
    />
  );
}
